import { useHistory, useLocation } from "react-router-dom";

const getQueryParamsAsObject = (search) => {
  const query = new URLSearchParams(search);
  const result = {};

  query.forEach((value, key) => {
    result[key] = value;
  });

  return result;
};

export default function useQueryAsState() {
  const { pathname, search, state } = useLocation();
  const history = useHistory();
  const query = getQueryParamsAsObject(search);

  const getNewSearch = (updatedQuery) => {
    Object.assign(query, updatedQuery);
    const resultQuery = Object.fromEntries(Object.entries(query).filter(([, v]) => v != null));
    return `?${new URLSearchParams(resultQuery).toString()}`;
  };

  const isQueryChanged = (updatedQuery) => {
    const newSearch = getNewSearch(updatedQuery);
    return search !== newSearch;
  };

  const updateQuery = (updatedQuery) => {
    const newSearch = getNewSearch(updatedQuery);
    if (search !== newSearch) {
      history.push(`${pathname}${newSearch}`, state);
    }
  };

  return [{ ...query }, updateQuery, history, isQueryChanged];
}
